import axios from 'axios';
import Cookies from 'js-cookie';

// Reserved virtual sender; matches both servers. Only authenticated HTTP supplies these updates.
export const ALPHAMD_SENDER_ID = '000000000000000000a1fa01';
export const ALPHAMD_LOGO = '/Images/alphamd-half-logo.png';
const endpoint = () => `${process.env.NEXT_PUBLIC_BASE_URL}/messages/system/alphamd`;
const config = () => ({ headers: { Authorization: `Bearer ${Cookies.get('token')}` } });
export async function getAlphaMdMessages(page = 1) {
  const { data } = await axios.get(endpoint(), { ...config(), params: { page } });
  return data;
}
export async function readAlphaMdMessages(throughMessageId) {
  await axios.post(`${endpoint()}/read`, { throughMessageId }, config());
}

export async function sendAlphaMdReply(body) {
  const { data } = await axios.post(`${endpoint()}/reply`, body, config());
  return data.data;
}
